import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import BaseActionButton from '@/components/BaseActionButton/index.vue'
import BaseSubmitButton from '@/components/BaseSubmitButton/index.vue'
import './styles/index.scss'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router/index.ts'
import i18n from "./locales/index.ts";
import { permission } from '@/directives/permission'
// SVG 图标
import 'virtual:svg-icons-register'
import SvgIcon from '@/components/svgIcon/index.vue'

const app = createApp(App)
// 全局错误提示
app.config.errorHandler = (err, vm, info) => {
  window.console.log('[全局异常]', err, vm, info)
}

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.component('BaseActionButton', BaseActionButton)
app.component('BaseSubmitButton', BaseSubmitButton)
// 全局注册 svg-icon 组件
app.component('svg-icon', SvgIcon)
app.use(createPinia() as any)
app.use(router as any)
app.use(i18n as any)
app.use(ElementPlus)
app.directive('permission', permission)
app.directive("focus", {
   mounted(el) {
     el.focus();
   },
 });

app.mount('#app')
